<template>
    <div class="h-full w-full flex flex-col gap-2">
        <UAlert variant="subtle" title="CSV-data" class="shrink-0">
            <template #description>
                Dette ser ut som CSV-data. Ønsker du å importere som transaksjoner?
                <UButton class="mt-2" @click="initImport">Ja, vis import-konfigurasjon</UButton>
            </template>
        </UAlert>
        <div v-if="rawContent" class="text-sm overflow-auto p-2">
            <pre>{{ rawContent }}</pre>
        </div>
    </div>
</template>

<script setup lang="ts">
import {onMounted, PropType, ref, watch} from 'vue'
import {storageGetFile} from '@/services/document.service'
import {useOverlay} from '@nuxt/ui/composables/useOverlay'
import CsvImportModal from '@/csv-transaction-importer/CsvImportModal.vue'
import {IncomingDocument} from '@/types/IncomingDocument'
import {useAttachDocumentService} from '@/transaction/create-transaction/AttachDocument.service'

const {isDocumentAttached, attachDocument} = useAttachDocumentService()

const props = defineProps({
    incomingDocument: {
        type: Object as PropType<IncomingDocument>,
        required: true
    }
})

const rawContent = ref()

const loadDocument = async () => {
    if(!props.incomingDocument?.documentMeta?.uuid) {
        rawContent.value = null
        return
    }
    const file = await storageGetFile(props.incomingDocument.documentMeta)
    rawContent.value = await file.text()
}

onMounted(loadDocument)
watch(() => props.incomingDocument?.documentMeta?.uuid, loadDocument)

const initImport = () => {
    const overlay = useOverlay()
    const modal = overlay.create(CsvImportModal)
    modal.open({
        data: rawContent.value
    })
    if (!isDocumentAttached(props.incomingDocument.documentMeta.uuid)) {
        attachDocument(props.incomingDocument)
    }
}
</script>

<style scoped>

</style>